// events
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbLoader from "../webb/webb-loader";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { GetUserEventsList } from "../../services/srvc-events-realm";
import { CreatePoapTransfers } from "../../services/srvc-transfers-realm";

export default function PoapCreateModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();

  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [form, setForm] = useState(false);
  const [text, setText] = useState('');

  const [list, setList] = useState('');
  const [evnt, setEvent] = useState('');
  const [data, setData] = useState({
    name: '',
    emid: '',
    enid: '',
    host: window.location.hostname === 'localhost' 
    ? 'http://localhost:3000'
    : 'https://wiseid-xr.web.app'
  })

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setList ((await GetUserEventsList(({
          data: {usid: asset.usid},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);


  // useEffect for form validation
  useEffect( () => {
    setForm(false);
    if (data.name!=='' && data.emid!=='' && data.enid!=='') 
      setForm(true);
  },[data]);


  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();    

    console.log (data)
    setLoading(true)
    const res = await CreatePoapTransfers({
      data: data, 
      user: asset.usid
    })
    
    setLoading(false)
    // console.log (res)
    // if (res.data) history.push(`/${UserForm()}/creds`)

  };

  if (loading){ return ( <> <WebbLoader /> </> ) }

  return (
  <>
    {/* info */}
    <WebbModuleInfo data={{text: 'Enter Details and Send POAP Claim'}}/>

    {/* form */}
    <form onSubmit={handleSubmit}>

      <div className="">

        <div className="form-group mb-3">
          <label className="form-label small">Event <FormNeeded /></label>
          <select 
            className="form-select height-md "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.enid}
            onChange={({ target }) => handleChange("enid", target.value)}
            >
              <option value =''>Select Event</option>
              {list && list.map((item,i) => (
              <option key={i} value={item.enid}>{item.name}</option>
            ))}
          </select>
        </div>


        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">User Name  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.name}
            onChange={({ target }) => {handleChange("name", target.value); setText('');}}
            placeholder="User Name">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">User Email  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.emid}
            onChange={({ target }) => {handleChange("emid", target.value); setText('');}}
            placeholder="user@mail.com">
          </input>
        </div>


      </div>

      {/* actn */}
      <WebbDividerMedium />      
      <div className={`mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
        <div className="d-grid">
          <button className={`btn height-md rounded-pill ${ form ? 'btn-primary back-color-main' : 'btn-primary back-color-main'}`}
            disabled={!form}
          ><small>Send POAP</small>
          </button>
        </div>
      </div>

    </form>


    <WebbDividerMedium/>
    <WebbDividerMedium/>
  </>
  )
}